import { autoinject, Container } from "aurelia-dependency-injection";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AlertsCourtModel } from "../models/alerts-court";
import { AppEvents } from "../../app-events";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const template = require<string>("../views/alerts-court.html");

const dom = {
    SLIDER: ".slider",
    COURT_ENABLED: ".court-enabled input"
};

@backboneViewProperties({
    tagName: "tr",
    template: template
})
@autoinject
export class AlertsCourtView extends Marionette.ItemView<AlertsCourtModel> {

    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.SLIDER] = (e) => this.sliderClick(e);
        return events;
    }

    private sliderClick(e: JQueryEventObject) {
        this.model.Enabled = !this.model.Enabled;
        this.saveAlert();
    }

    private saveAlert() {
        this.appEvents.trigger(AppEvents.AppInsightsAlertChange, {Type: "Court", Value: this.model.CourtName, Enabled: this.model.Enabled});

        this.model.saveAlert().then(() => {
            this.$(dom.COURT_ENABLED).prop("checked", this.model.Enabled);
            this.$(dom.COURT_ENABLED).val("" + this.model.Enabled);
            this.appEvents.trigger(AppEvents.InformationMessage, "The alert for " + this.model.CourtName + " has been " + (this.model.Enabled ? "Enabled" : "Disabled"));
        }, () => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert for " + this.model.CourtName);
            this.RevertCheckbox();
        }).catch((exception) => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert for " + this.model.CourtName);
            this.RevertCheckbox();
        });
    }

    private RevertCheckbox() {
        this.model.Enabled = !this.model.Enabled;
        this.$(dom.SLIDER).prop("checked", this.model.Enabled);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-court.ts